import { TranslationString } from 'shared/entities/localization';
import {
  AITarget,
  AITargetServer,
  mapAITargetToTitle
} from 'shared/entities/smartbotAIInfo';

export class AITargetModel {
  kind: AITarget;
  text: string;

  constructor({ kind, text }: { kind: AITarget; text: string }) {
    this.kind = kind;
    this.text = text;
  }

  // получаем значение не из this.text для того,  чтобы поддержать английскую версию
  get title(): TranslationString {
    return mapAITargetToTitle(this.kind);
  }

  get id(): string {
    return this.kind;
  }

  static fromJson(raw: AITargetServer): AITargetModel {
    return new AITargetModel({
      kind: raw.kind,
      text: raw.text
    });
  }
}
